import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=0a8c3c6c&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=0a8c3c6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8c3c6c",
  null
  
)

export default component.exports